import { render, staticRenderFns } from "./justice-is-blind-info.vue?vue&type=template&id=5e585d13&scoped=true&lang=pug&"
import script from "./justice-is-blind-info.vue?vue&type=script&lang=js&"
export * from "./justice-is-blind-info.vue?vue&type=script&lang=js&"
import style0 from "./justice-is-blind-info.vue?vue&type=style&index=0&id=5e585d13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e585d13",
  null
  
)

export default component.exports